
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'ContactForm',
  setup() {
    const name = ref('');
    const email = ref('');
    const message = ref('');
    const submitted = ref(false);
    const submitting = ref(false);
    const error = ref('');

    const handleSubmit = async () => {
      if (!name.value || !email.value || !message.value) {
        return;
      }

      submitting.value = true;
      error.value = '';

      try {
        const response = await fetch('https://api.web3forms.com/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            access_key: '937c07a0-ee16-4bad-9ed0-3fc90de977f1',
            subject: 'New contact from bryanchriswhite.com',
            name: name.value,
            email: email.value,
            message: message.value,
          }),
        });

        const data = await response.json();

        if (data.success) {
          submitted.value = true;
          name.value = '';
          email.value = '';
          message.value = '';
        } else {
          error.value = 'Something went wrong. Please try again or email me directly.';
        }
      } catch {
        error.value = 'Failed to send message. Please try again or email me directly.';
      } finally {
        submitting.value = false;
      }
    };

    return {
      name,
      email,
      message,
      submitted,
      submitting,
      error,
      handleSubmit,
    };
  },
});
